import React from "react";

export default function ErrorMessage(props) {
  return <div>{props.children}</div>;
}
